import { COMPANY, NAV_LINKS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="border-t border-emerald-900/60 surface-page py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-10 items-start">
        <div>
          <div className="flex items-center gap-3">
            <img src={COMPANY.logo} alt="crest" className="w-12 h-12 object-contain rounded-lg" />
            <div className="leading-tight">
              <div className="font-display text-sm tracking-[0.15em] text-emerald-50 uppercase">Jahzara Phenix Jae Orion LLC</div>
              <div className="text-[10px] tracking-[0.3em] text-gold uppercase">Holding Company · Est. {COMPANY.established}</div>
            </div>
          </div>
          <p className="text-sm text-slate-500 mt-4 max-w-xs">{COMPANY.tagline}</p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-slate-400 mb-4">Navigate</div>
          <div className="flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} className="text-sm text-slate-400 hover:text-gold transition-colors w-fit">{l.label}</a>
            ))}
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-slate-400 mb-4">The House</div>
          <p className="text-sm text-slate-400">{COMPANY.domain}</p>
          <p className="text-sm text-slate-500 mt-2">Luchii AI Models · Frasberg AI Models</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t border-emerald-900/40 flex flex-col sm:flex-row justify-between gap-3 text-[11px] text-slate-600 tracking-wide">
        <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
        <span>AI Operating Company</span>
      </div>
    </footer>
  );
}
